export var getContactSupportUrl = function (group) {
    if (!group || !group.supportPageUrl) {
        return '';
    }
    return group.supportPageUrl + "/" + group.sku + "/contact-support";
};
